"use strict";
"use client";
import { FocusTrap as FocusTrap$1 } from '@ark-ui/react/focus-trap';
import { chakra } from '../../styled-system/factory.js';

const FocusTrap = chakra(FocusTrap$1);

export { FocusTrap };
